module.exports = __webpack_public_path__ + "assets/061bd47ec3ad8f57ab55a25a94282cc1.png";